
import Vue from 'vue';
import Component from 'vue-class-component';
import {Watch} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';

@Component({})
export default class OturumLimitiDialog extends Vue {
  @Getter oturumLimitiUyarisi!: { zaman: number } | null;
  @Getter isUyapConnected!: boolean;
  @Action connectToUyap!: (payload?: { force?: boolean }) => Promise<void>;
  @Action oturumLimitiUyarisiniKapat!: () => void;

  baglaniyor = false;

  get acik(): boolean {
    return this.oturumLimitiUyarisi !== null;
  }

  set acik(v: boolean) {
    // persistent dialog; kapatma yalnızca düğmelerden veya bağlantı gelince.
    if (!v) this.kapat();
  }

  // Arka plandaki kurtarma döngüsü bağlantıyı geri kurunca pencere kendiliğinden kapanır.
  @Watch('isUyapConnected')
  onBaglanti(bagli: boolean) {
    if (bagli && this.acik) {
      this.oturumLimitiUyarisiniKapat();
    }
  }

  kapat() {
    this.oturumLimitiUyarisiniKapat();
  }

  async simdiDene() {
    this.baglaniyor = true;
    try {
      // Kullanıcının açık talebi: oturum geçerlilik kontrolü atlanır (force).
      await this.connectToUyap({force: true});
      this.oturumLimitiUyarisiniKapat();
    } catch (e) {
      // Hata durum mesajına yazılır; dialog açık kalsın ki kullanıcı tekrar deneyebilsin.
    } finally {
      this.baglaniyor = false;
    }
  }
}
